import { useMutateData } from "shared/services/base.service";
const BaseServicePathStandard = process.env.REACT_APP_API_STANDARD;
const BaseServicePathCommon = process.env.REACT_APP_API_COMMON;

const AuthService = () => ({
  useLogin: () => {
    const { mutate } = useMutateData({
      invalidateKeys: [],
    });
    return async payload => {
      return await mutate({
        url: `${BaseServicePathStandard}/user/info`,
        method: "POST",
        data: payload,
      });
    };
  },
  useGetRoleUser: () => {
    const { mutate } = useMutateData({
      invalidateKeys: ["user-role"],
    });
    return async payload => {
      return await mutate({
        // url: `${BaseServicePathCommon}/access-control/sca-role`,
        url: `${BaseServicePathCommon}/access-control/function`,
        method: "POST",
        data: payload,
      });
    };
  },
  useGetRoleUserSca: () => {
    const { mutate } = useMutateData({
      invalidateKeys: ["user-role-sca"],
    });
    return async payload => {
      return await mutate({
        url: `${BaseServicePathCommon}/access-control/sca-role`,
        method: "POST",
        data: payload,
      });
    };
  },
});
export const { useLogin, useGetRoleUser, useGetRoleUserSca } = AuthService();
